// Node Module Imports
import React from 'react'

import styled from 'styled-components'

// Asset Imports
import chevGreen from '../../../assets/images/backgrounds/chev-green.jpg'
// Style Imports
import { space } from '../../../style/design-system'
import UtilityHeader from '../../headers/UtilityHeader'

const NewsRoomHero = ({ className }) => (
  <UtilityHeader className={className}>
    <div className="container">
      <div className="h1">Newsroom</div>
      <p>Stay up to date with the latest press releases and news.</p>
    </div>
  </UtilityHeader>
)

export default styled(NewsRoomHero)`
  background: url(${chevGreen});
  background-size: contain;
  color: #fff;

  .h1 {
    margin-bottom: ${space.c};
    margin-top: 0;
  }

  p {
    color: #fff;
    margin-bottom: 0;
    margin-top: 0;
  }
`
